import type { ShapeData } from '@/lib/shapes/types/shape-data'

/** Where a shape sits on the canvas. A move drag changes only these on every frame. */
const POSITION_KEYS = new Set<string>(['x', 'y'])

function sameShapeIgnoringPosition(a: ShapeData, b: ShapeData): boolean {
  if (a === b) return true

  const aKeys = Object.keys(a)

  if (aKeys.length !== Object.keys(b).length) return false

  return aKeys.every(
    (key) =>
      POSITION_KEYS.has(key) ||
      (Object.prototype.hasOwnProperty.call(b, key) &&
        Object.is(a[key as keyof ShapeData], b[key as keyof ShapeData]))
  )
}

/**
 * True when two selection lists hold the same objects in the same order, field for field, except
 * for their position. Size, rotation, lock/freeze state and content all still count as a change.
 */
export function sameSelectionIgnoringPosition(
  a: readonly ShapeData[],
  b: readonly ShapeData[]
): boolean {
  if (a === b) return true
  if (a.length !== b.length) return false

  return a.every((shape, i) => sameShapeIgnoringPosition(shape, b[i]))
}
